// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"11":"9b59ffee","253":"9b59ffee","293":"e5fecb29","450":"9b59ffee","613":"9b59ffee","961":"9b59ffee","964":"e5fecb29","978":"9b59ffee"}[chunkId] + ".chunk.css";
};